import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const stowedWeightExceedsNominatedWeightHardRule: StowageRuleBM = {
    id: StowageRuleId.StowedWeightExceedsNominatedWeightHardRule,
    name: 'Stowed weight exceeds total nominated weight',
    lastUpdatedUtc: '2025-09-11T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Stowed weight',
                            fieldPath: 'getCargoOperationStowedWeight',
                            type: 'number',
                            location: StowageRulePropertyLocation.NA,
                        },
                        {
                            name: 'Nominated weight',
                            fieldPath: 'getCargoOperationNominatedWeight',
                            type: 'number',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.CargoOperation,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Stowed weight',
                            fieldPath: 'getCargoOperationStowedWeight',
                            type: 'number',
                            location: StowageRulePropertyLocation.NA,
                        },
                        {
                            name: 'Reference value',
                            type: 'number',
                            referenceValue: '0',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.CargoOperation,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
            // Apply only when the voyage is in Scheduled status. If voyage has Commenced or Completed status, rule will not trigger.
            {
                leaf: {
                    properties: [
                        {
                            name: 'Voyage status',
                            fieldPath: 'cargoOperation.berthCall.portCall.voyageStatus',
                            type: 'string',
                            location: StowageRulePropertyLocation.NA,
                        },
                        {
                            name: 'Reference value',
                            type: 'string',
                            referenceValue: 'Scheduled',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.CargoOperation,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'Stowed weight exceeds total nominated weight',
    },
};
